export default __webpack_public_path__ + "static/ttpro-b72e011a2d73d65a901fab8ec2999de3.svg";